import React from "react"
// import { Link } from "gatsby"
import Container from "../components/container.js"
import style from "./index.module.css"

export default function Home() {
  return (
    <Container>
      <div className={style.index}>
        <h4>Interests</h4>
        <p>
          I am interested in software, machine learning, and technologies that
          power the web (this website is built in{" "}
          <a href="https://gatsbyjs.com" target="_blank">
            Gatsby
          </a>
          ). In my free time, I like to go swimming and hiking :).
        </p>

        <h4>Background</h4>
        <p>
          I have a background in business administration and computer science
          and studied at{" "}
          <a href="https://www.cdtm.com" target="_blank" rel="noreferrer">
            CDTM
          </a>
          ,{" "}
          <a href="https://berkeley.edu" target="_blank" rel="noreferrer">
            UC Berkeley
          </a>
          ,{" "}
          <a href="https://www.tum.de" target="_blank" rel="noreferrer">
            TUM
          </a>
          , and{" "}
          <a href="https://www.cbs.dk" target="_blank" rel="noreferrer">
            Copenhagen Business School
          </a>
          .
          <br />I worked in management consulting at McKinsey & Company and
          developed software at scale at{" "}
          <a href="https://www.throne.com" target="_blank" rel="noreferrer">
            Throne
          </a>
          . Throne is an ecommerce platform with more than $100m GMV and more
          than 100m page views per month. As employee number three, I was
          responsible for building out key infrastructure, optimizing the
          platform, and building product features creating ~$2m in annual
          revenue for the company.
        </p>
        <h4>Currently</h4>
        <p>
          With the rise of ChatGPT, I decided to pursue a career in software
          engineering centered around AI.
          <br />
          For the past two years, I've been serving startups and mid-sized
          companies as a forward deployed AI engineer, creating custom AI
          automations of human workflows from concept to production. A typical
          project involves understanding processes together with my client's
          teams, gathering data and building a proof of concept to prove value,
          and integrating the solution into the client's existing software
          infrastructure to generate massive savings and productivity gains.
          I've worked with clients in many verticals, including finance, health
          care, procurement, real estate, and recruiting. <br />
        </p>
        {/* <h4>Articles and projects</h4>
          <p>I posted some of my articles and projects <Link to="/articles/">here</Link>.</p> */}
        <h4>Projects</h4>
        <p>
          Most of my projects live on my{" "}
          <a href="https://github.com/stefanbielmeier" target="_blank">
            {" "}
            GitHub
          </a>
          .
        </p>
      </div>
    </Container>
  )
}
